export default __webpack_public_path__ + "static/media/erp.59c82671.jpg";